'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');

/**
 * Calculate remaining time respecting server time offset
 * @deprecated
 * @param {ReactComponent} component
 * @param {object} [options]
 * @param {number|Function} [options.interval=1000] - Minimum interval to wait before updating
 * @param {number} [options.propName="currentTime"] - Injected prop name
 */

function withCurrentTime(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('DEPRECATED', 'withCurrentTime is deprecated and will be removed.', 'Use <Timestamp> component instead.');
  } // eslint-disable-next-line react/no-deprecated


  return (
    /*#__PURE__*/
    function (_React$Component) {
      __chunk_1.inherits(CurrentTime, _React$Component);

      function CurrentTime(props) {
        var _this;

        __chunk_1.classCallCheck(this, CurrentTime);

        _this = __chunk_1.possibleConstructorReturn(this, __chunk_1.getPrototypeOf(CurrentTime).call(this, props));
        _this.handleTick = _this.handleTick.bind(__chunk_1.assertThisInitialized(_this));
        _this.state = {
          timestamp: Date.now()
        };
        return _this;
      } // eslint-disable-next-line react/no-deprecated


      __chunk_1.createClass(CurrentTime, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          this.timerId = this.handleTick();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          clearInterval(this.timerId);
        }
      }, {
        key: "handleTick",
        value: function handleTick() {
          var _this2 = this;

          var interval = typeof options.interval === 'function' ? options.interval() : options.interval || 1000;
          return setTimeout(function () {
            _this2.setState({
              timestamp: Date.now()
            });

            _this2.timerId = _this2.handleTick();
          }, interval);
        }
      }, {
        key: "render",
        value: function render() {
          var hocProps = __chunk_1.defineProperty({}, options.propName || 'currentTime', this.state.timestamp);

          return React__default.createElement(Component, __chunk_1.extends({}, this.props, hocProps));
        }
      }]);

      return CurrentTime;
    }(React__default.Component)
  );
}

exports.withCurrentTime = withCurrentTime;
//# sourceMappingURL=with-current-time.js.map
